import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Player from '@app/components/Player'
import { statePath } from '@app/helpers/studentsHelper'
import { AbilityContext } from '@app/context/ability-context'
import * as actions from '@app/actions/students'

class TaskContainer extends Component {
  static contextType = AbilityContext;

  constructor(props) {
    super(props)
    this.handleBack = this.handleBack.bind(this)
  }

  handleBack(payload) {
    const {
      boundActions, route: { history, match: { params: { tour, id } } }
    } = this.props

    boundActions.invalidateTasks(tour)


    if (tour === 'main' && !!payload) {
      setTimeout(() => {
        history.replace(`/students/tours/${tour}/tasks/${id}/answer`)
      }, 1000);
    } else {
      history.replace(statePath(this.context))
    }
  }

  render() {
    const { route: { history, match: { params: { tour, id } } } } = this.props

    return (
      <Player
        src={`/api/students/tours/${tour}/tasks/${id}`}
        onBack={this.handleBack}
      />
    )
  }
}

TaskContainer.propTypes = {
  route: PropTypes.object.isRequired
};

const mapDispatchToProps = (dispatch) => {
  return { boundActions: bindActionCreators(actions, dispatch) }
}

export default connect(
  null,
  mapDispatchToProps,
  null, {
    getDisplayName: () => "Task"
  }
)(TaskContainer)
